import { connect } from 'react-redux'
import { IAppState } from 'core/store/store'
import ApiTokenForm from './ApiTokenForm'
import { ApiTokenFormStateProps } from './ApiTokenForm.types'

export default connect(
  (state: IAppState): ApiTokenFormStateProps => {
    return {
      accessScope: state.profile.data?.access_scope,
      profileAccessScope: state.profile.data?.access_scope,
      dateFormat: state.profile.data?.date_format
    }
  }
)(ApiTokenForm)
